<template>
    <div ref="container" style="height: 100%"></div>
</template>
<script>
import bb, {bar} from "billboard.js";
import { chartColumnLabel, resolveChartDisplayValue } from '../display'
// import "billboard.js/dist/billboard.css";

export default{
    props: {
        widgets: {
            type: Object,
            required: true,
        },
        data: {
            type: Array,
            required: true,
        },
        additional: Object,
        fieldMeta: Object,
        paddingSize: {
            type: Number,
            default: 50,
        }
    },
    mounted(){
        this.draw()
    },
    computed: {
        x(){
            const x = [];
            this.widgets.dimensions.forEach((dimension) => {
                x.push(dimension.Name);
            });
            return x;
        },
        axises(){
            const axises = {};
            this.widgets.dimensions.forEach((dimension) => {

                let categories = [];
                if(this.data && this.data.forEach){
                    this.data.forEach((row) => {
                        categories.push(resolveChartDisplayValue(row[dimension.Name], this.fieldMeta?.[dimension.Name], this.additional));
                    });
                }

                axises["x"] = {
                    type: "category",
                    categories,
                    tick: {
                        rotate: -70,
                        multiline: false,
                        tooltip: true
                    }
                }
            });
            return axises;
        },
        columns(){
            const columns = [];
            this.widgets.measures.forEach((measure) => {
                let column = [chartColumnLabel(measure)];
                if(this.data && this.data.length){
                    this.data.forEach((row) => {
                        column.push(row[measure.Name]);
                    });
                }
                columns.push(column);
            });
            return columns;
        }
    },
    methods: {
        draw(){
            const chart = bb.generate({
                bindto: this.$refs.container,
                data: {
                    columns: this.columns,
                    type: bar(),
                    labels: true,
                },
                bar: {
                    width: {
                        ratio: 0.5
                    }
                },
                legend: {
                    show: false
                },
                padding: {
                    mode: "fit",
                    top: this.paddingSize,
                    bottom: this.paddingSize,
                    left: this.paddingSize,
                    right: this.paddingSize,
                },
                axis: this.axises,
            });
        }
    }
}
</script>
